<template>
  <div v-show="meterNotification.isMeterOffline && isCheckMeterOffline">
    <div class="alert-meter" role="alert">
      <div class="close-box">
        <v-btn class="close" icon @click="isCheckMeterOffline = false">
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="media" @click="dialogCheckMeter = true">
        <div class="media-left">
          <v-btn text class="btn-meter">
            <img width="60px" class="media-object" src="../assets/images/meter-offline-noti.png" alt="meter-offline-icon" />
          </v-btn>
        </div>
        <div class="media-body">
          <h4 class="media-heading" style="line-height: unset;">
            <v-btn color="white" text class="btn-meter">
              <b>{{ $t('meter.offline_electricity_meter') }}</b>
            </v-btn>
          </h4>
          <span  class="mr-2 text-white">
            {{ meterNotification.count }} {{ $t('meter.title') }}
          </span>
        </div>
      </div>
    </div>
    <template>
      <v-dialog v-model="dialogCheckMeter" max-width="900" persistent scrollable>
        <v-card>
          <v-card-title class="justify-end pb-0 pt-1">
            <v-btn icon @click="dialogCheckMeter = false" small>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" lg="6">
                <div class="container-dialog-meter">
                  <div class="header">
                    <img class="icon-warning" src="@/assets/images/warning-icon.png" alt="">
                    <h1 class="mt-4">WARNING</h1>
                  </div>
                  <div class="body">
                    <div>
                      <v-alert color="error" dense class="py-1">
                        <div class="text-white text-center">Gateway Offline</div>
                      </v-alert>
                    </div>
                    <div class="detail mb-2 text-center">
                      {{ $t('meter.first_check_at_gateway_or_signal') }} <br>
                      {{ $t('meter.your_internet_to_keep_gateway_online') }}
                    </div>
                    <div class="detail warning-box">
                      <img src="@/assets/images/plug.png" alt="plug-gate-way" class="plug">
                      <div class="text-error mb-3">{{ $t('meter.warning') }}</div>
                      <div>
                        {{ $t('meter.do_not_turn_off_or_remove_the_power_plug_from_the_machine') }} <br>
                        {{ $t('meter.it_will_cause_the_meter_to_not_be_read_through_the_system') }} <br>
                        {{ $t('meter.or_can_not_see_the_electricity_usage_history') }}
                      </div>
                    </div>
                    <div class="d-flex align-center justify-center my-2">
                      <img width="30" src="@/assets/images/ling.png" alt="line" class="me-3">
                      <a href="#">@myketpro</a>
                    </div>
                    <div class="text-center">
                      <div>{{ $t('project.ask_for_more_details') }}</div>
                      <div class="my-2">{{ $t('project.call_us') }}</div>
                      <div class="grey--text">{{ $t('project.call_us_time') }}</div>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <div class="txt-title text-center font-weight-bold">{{ $t('meter.offline_meter') }} {{ meterNotification.listMeterOffline.length }} {{ $t('meter.title') }}</div>
                <div class="list-meter-offline">
                  <div class="list-meter-offline-item" v-for="(item ,index) in meterNotification.listMeterOffline" :key="index" @click="$emit('clickDialogGoTo', item.area, 'MeterDigital')">
                    <div class="d-flex align-center">
                      <img width="60px" class="media-object" src="../assets/images/meter-offline-noti.png" alt="meter-offline-icon" />
                      <div class="detail">
                        <div>
                          <span class="font-weight-bold">{{ $t('area.shop') }} : {{ item.businessName }}</span> ({{ item.areaName }})
                        </div>
                        <div>{{ $t('meter.meter_name') }} : {{ item.meterName }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
       
      </v-dialog>
    </template>
  </div>
</template>

<script>
export default {
  components: {
  },
  created() {
  },
  props: {
    meterNotification: {
      type: Object
    }
  },
  watch: {
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      isLoading: false,
      isCheckMeterOffline: true,
      dialogCheckMeter: false,
    };
  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.alert-meter {
  position: relative;
  margin-bottom: 10px;
  background: rgba(235, 84, 85, 0.7);
  animation: zoomIn 0.4s;
  -webkit-animation: zoomIn 0.4s;
  border-color: rgba(235, 84, 85, 0.7);
  border: 1px solid transparent;
  border-radius: 4px;
  transition: transform 0.3s ease;
}

.alert-meter:hover {
  transform: scale(1.01);
}

.media {
  margin-top: 0;
  padding: 15px;
  overflow: hidden;
  zoom: 1;
  cursor: pointer;
}

.media-body,
.media-left {
  display: table-cell;
  vertical-align: top;
}

.media-left {
  padding-right: 10px;
}

.media-object {
  display: block;
}

.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
  line-height: unset;
}

.btn-meter {
  height: unset !important;
  padding: 0 !important;
  font-size: 18px;
  letter-spacing: 0;
}

.close-box {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  top: 0;
  right: 0;
  align-items: flex-end;
  height: 100%;
  padding: 5px 10px;
}

.close {
  font-size: 21px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.2);
  background: var(--v-light-base);
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.bg-red{
  background-color: rgba(235, 84, 85, 0.8) !important;
}
.container-dialog-meter{
  border: none !important;
  position: relative;
  background:var(--v-light-base);
  .header{
    background-color: rgba(235, 84, 85, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 187px;
    color: var(--v-light-base);
    flex-direction: column;
    .abs-icon-close{
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .icon-warning{
      width: 90px;
      height: 90px;
      object-fit: contain
    }
  }
  .body{
    padding: 20px 0px 0px 0px;
    background:var(--v-light-base);
    .detail{
      font-size: 16px;
      &.warning-box{
        text-align: center;
        padding: 20px;
        img.plug{
          margin: 0 auto;
          width: 80px;
          height: 50px;
          object-fit: contain;
        }
        background-color: rgba(255, 224, 220, 1);
        border-radius: 5px;

      }
    }
  }
}

.text-error{
  color: rgba(235, 84, 85, 1);
}
.list-meter-offline{
  max-height: 600px;
  overflow-y: auto;
  height: 100%;
  .list-meter-offline-item{
    background-color: #EEEEEE;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid rgba(235, 84, 85, 0.3);
    cursor: pointer;
    .detail{
      margin-left: 20px;
      font-size: 16px;
      color: #000;
    }
    &:not(:last-child){
      margin-bottom: 10px;
    }
  }
}
.txt-title{
  font-size: 16px;
  margin-bottom: 10px;
  color: #000;
}
</style>